import React from 'react';
import './DateFilter.css';

interface DateFilterProps {
  selectedDate: Date | null;
  onSelectDate: (date: Date | null, isWeekendFilter?: boolean) => void;
}

const DateFilter: React.FC<DateFilterProps> = ({ selectedDate, onSelectDate }) => {
  const getToday = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  const getWeekend = () => {
    const today = new Date();
    const day = today.getDay();
    const daysUntilSaturday = (6 - day + 7) % 7;
    const saturday = new Date(today);
    saturday.setDate(today.getDate() + daysUntilSaturday);
    saturday.setHours(0, 0, 0, 0);
    return saturday;
  };

  const isToday = (date: Date) => {
    const today = getToday();
    return date.getTime() === today.getTime();
  };

  const isWeekend = (date: Date) => {
    const saturday = getWeekend();
    const sunday = new Date(saturday);
    sunday.setDate(saturday.getDate() + 1);
    return date.getTime() === saturday.getTime() || date.getTime() === sunday.getTime();
  };

  const quickFilters = [
    {
      label: 'Today',
      date: getToday(),
      isActive: selectedDate ? isToday(selectedDate) : false,
      isWeekend: false,
    },
    {
      label: 'This Weekend',
      date: getWeekend(),
      isActive: selectedDate ? isWeekend(selectedDate) : false,
      isWeekend: true,
    },
    {
      label: 'All Dates',
      date: null,
      isActive: selectedDate === null,
      isWeekend: false,
    },
  ];

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      const date = new Date(e.target.value + 'T00:00:00');
      onSelectDate(date, false);
    } else {
      onSelectDate(null, false);
    }
  };

  const formatDateForInput = (date: Date | null) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="date-filter">
      <h3 className="date-title">When?</h3>
      <div className="quick-filters">
        {quickFilters.map((filter) => (
          <button
            key={filter.label}
            className={`quick-filter-btn ${filter.isActive ? 'active' : ''}`}
            onClick={() => onSelectDate(filter.date, filter.isWeekend)}
          >
            {filter.label}
          </button>
        ))}
      </div>
      <div className="custom-date">
        <label htmlFor="date-picker" className="date-label">
          📅 Pick a specific date:
        </label>
        <input
          id="date-picker"
          type="date"
          value={formatDateForInput(selectedDate)}
          onChange={handleDateChange}
          className="date-picker-input"
          min={formatDateForInput(getToday())}
        />
      </div>
    </div>
  );
};

export default DateFilter;
